import {Breadcrumb, Col, Divider, Row} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import Markdown from 'react-markdown'

function Contacts() {

    const [content, setContent] = useState({});

    const [skeleton, setSkeleton] = useState(true);

    const apiKey = process.env.REACT_APP_STRAPI_CMS_API_KEY;

    const toggleSceleton = (value, key) => {
        if (key in value) {
            setSkeleton(false);
        } else {
            setSkeleton(true);
        }
    }

    const getMenu = async () => {
        const response = await axios.get(
            process.env.REACT_APP_STRAPI_URL + "/api/contact/?populate=*",
            {
                headers: {
                    'Authorization': 'Bearer ' + apiKey
                }
            }
        )
        console.log(response.data.data.attributes);
        const content = response.data.data.attributes;

        setContent(content);
        toggleSceleton(content, 'Title');
    }

    useEffect(() => {
        getMenu().then(r => {});
    }, []);

    return (
        <>
            <Row gutter={24} className={"Content Title"} style={{paddingBottom: 0}}>
                <Col span={12}>
                    <h1>{content.Title}</h1>
                </Col>
                <Col span={12}>
                    <Breadcrumb
                        style={{float: "right"}}
                        items={[
                            {
                                href: '/',
                                title: (
                                    <>
                                        <span>Home</span>
                                    </>
                                ),
                            },
                            {
                                title: 'Contacts',
                            },
                        ]}
                    />
                </Col>
            </Row>
            <Row gutter={24} className={"Content"} style={{paddingTop: 0}}>
                <Col span={12}>
                    <Divider className={"TransitionColors"} orientation="right">
                        <h3>{content.LeftColumnTitle}</h3>
                    </Divider>
                    <Markdown>{content.LeftColumnContent}</Markdown>
                </Col>
                <Col span={12}>
                    <Divider className={"TransitionColors"} orientation="right">
                        <h3>{content.RightColumnTitle}</h3>
                    </Divider>
                    <Markdown>{content.RightColumnContent}</Markdown>
                </Col>
            </Row>
        </>
    )
}

export default Contacts